export { ProductImageSection } from './product-image-section'
export type { ProductImageSectionProps } from './product-image-section'
